/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, InputAdornment, Tooltip, IconButton, Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import EditIcon from '@material-ui/icons/Edit';
import services from '../Service';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Delete from '@material-ui/icons/Delete';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { AlertDialog } from './../../Common/AlertDialog';
import Chip from '@material-ui/core/Chip';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import SearchNotFound from '../../../SearchNotFound';
import CheckIcon from '@material-ui/icons/Check';
import MoreVertIcon from '@material-ui/icons/MoreVert';

var screenCode = "ORDERAMENDEMENT"
export default function OrderAmendmentView(props) {
  const navigate = useNavigate();
  const { productID } = useParams();
  const [supplierOrderDeails, setSupplierOrderDeails] = useState([]);
  const [supplierOrderDeailsTwo, setSupplierOrderDeailsTwo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [supplierOrderUpdateDeails, setSupplierOrderUpdateDeails] = useState([]);
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: true,
    submitButtonName: 'Update',
    pageheadername: 'View FCC Orders'
  });

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = (data) => {
    setIsUpdate(false);
    setSupplierOrderDeails(data);
    trackPromise(GetMergeCropDetailsByPerformOrderID(data));
    //trackPromise(GetSupplierDetailsForOrder(data));
    setSupplierData({
      ...supplierData,
      reaminCount: data.reaminingQuantity,
    });
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsUpdate(false);
    setIsLoading(false);
    addSupplierClearFields();
  };

  const [open1, setOpen1] = useState(false);
  const handleClickOpen1 = (data) => {
    setSupplierOrderDeailsTwo(data);
    setOpen1(true);
  };
  const handleClose1 = () => {
    setReturnOrderData({
      ...returnOrderData,
      reason: ''
    });
    setOpen1(false);
  };
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOrderBreakdownList([])
    setOpen2(false);
  };
  const [groupList, setGroupList] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [supllierDetails, setSupllierDetails] = useState([]);
  const [mergeCropDetails, setMergeCropDetails] = useState([]);
  const [supllierVarityDetails, setSupllierVarityDetails] = useState([]);
  const [supllierVarityDetailsTwo, setSupllierVarityDetailsTwo] = useState([]);
  const [orderBreakdown, setOrderBreakdownList] = useState([]);
  const [orderBreakdownTotal, setOrderBreakdownTotal] = useState(0);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [orderApprovePopUpDetails, setOrderApprovePopUpDetails] = useState([]);
  const [message, setMessage] = useState("Order Approve Confirmation");
  const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);

  const [removeSupplierDetails, setRemoveSupplierDetails] = useState([]);
  const [removeSupplierOrderDetails, setRemoveSupplierOrderDetails] = useState([]);
  const [message2, setMessage2] = useState("Supllier Remove Confirmation");
  const [EnableConfirmMessage2, setEnableConfirmMessage2] = useState(false);

  const [readyToWeighmentDetails, setReadyToWeighmentDetails] = useState([]);
  const [message3, setMessage3] = useState("Ready To Weighment Confirmation");
  const [EnableConfirmMessage3, setEnableConfirmMessage3] = useState(false);

  const [date, setDate] = React.useState(new Date());
  const [isTable, setIsTable] = useState(false);
  const [formData, setFormData] = useState({
    groupID: 0,
    operationEntityID: 0,
    dataID: date.toISOString().split('T')[0],
    unitPrice: '250',
    date: date.toISOString().split('T')[0]
  });

  const [supplierData, setSupplierData] = useState({
    cropID: 0,
    cropName: '',
    farmerID: 0,
    farmerName: '',
    cropVarityID: 0,
    varietyName: '',
    quantity: 0,
    date: '',
    reaminCount: 0,
    availbaleQty: 0,
    cropForecastDetailID: 0
  });

  const [returnOrderData, setReturnOrderData] = useState({
    reason: '',
  });

  const PopUpStyle = makeStyles((theme) => ({
    root: {
      '& > *': {
        width: '25ch'
      }
    }
  }));

  const useStyles = makeStyles({
    root: {
      width: '100%',
      overflowX: 'auto'
    },
  });

  const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
  });
  const popUpClass = PopUpStyle();
  const classes = useStyles();

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(true);
    const classes = useRowStyles();

    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row" align='left'>{row.productName}</TableCell>
          <TableCell align="left">{row.productCode}</TableCell>
          <TableCell align="right">{parseFloat(row.realizedPrice).toFixed(2)}</TableCell>
          <TableCell align="right">
            {actionColumnOne(row)}
          </TableCell>
          <TableCell align="right">{parseFloat(row.quantity).toFixed(2)}</TableCell>
          <TableCell align="right">{parseFloat(row.acceptedQuantity).toFixed(2)}</TableCell>
          <TableCell align="right">{parseFloat(row.reaminingQuantity).toFixed(2)}</TableCell>
          <TableCell align="right">{parseFloat(row.returnQuantity).toFixed(2)}</TableCell>
          <TableCell align="center">
            <Tooltip title="More Details">
              <IconButton aria-label="delete"
                onClick={() => (viewFccOrderBreakdown(row))}
              >
                <MoreVertIcon />
              </IconButton>
            </Tooltip>
            {row.statusID != 1 && row.reaminingQuantity > 0 ?
              <Tooltip title="Add Supplier">
                <IconButton onClick={() => handleClickOpen(row)}>
                  <AddBoxIcon />
                </IconButton>
              </Tooltip> : null}
            {row.statusID != 1 && row.reaminingQuantity > 0 ?
              <Tooltip title="Return Order">
                <IconButton onClick={() => handleClickOpen1(row)}>
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip> : null}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              {row.farmerModel.length != 0 ?
                <Box margin={1} marginLeft={17}>
                  <Typography variant="h7" gutterBottom component="div">
                    <b>Supplier Details</b>
                  </Typography>
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Supplier&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Plot</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Crop</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>SKU</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Crop Variety</TableCell>
                        <TableCell align="right" style={{ fontWeight: 'bold' }}>Accepted Qty</TableCell>
                        <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row.farmerModel.map((historyRow) => {
                        let GivenName = historyRow.givenName == null ? "" : historyRow.givenName
                        let Surname = historyRow.firstName == null ? "" : historyRow.firstName
                        let Nic = historyRow.nic == null ? "" : historyRow.nic
                        return (
                          <TableRow key={historyRow.performOrderFarmerMappingID}>
                            <TableCell align="left" component="th" scope="row">
                              {GivenName + ' ' + Surname + ' - ' + Nic}
                            </TableCell>
                            <TableCell align="left" component="th" scope="row">
                              {historyRow.plotName}
                            </TableCell>
                            <TableCell align="left">{historyRow.productName}</TableCell>
                            <TableCell align="left">{historyRow.productCode}</TableCell>
                            <TableCell align="left">{historyRow.varietyName}</TableCell>
                            <TableCell align="right">{parseFloat(historyRow.acceptedQuantity).toFixed(2)}</TableCell>
                            <TableCell align="center">
                              {historyRow.statusID == 1 ?
                                <>
                                  <Tooltip title="Remove Supplier">
                                    <IconButton aria-label="delete"
                                      onClick={() => removeSupplierPopUp(row, historyRow)}>
                                      <Delete />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Edit Supplier" >
                                    <IconButton aria-label="delete"
                                      onClick={() => setUpdateSupplier(row, historyRow)}
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  </Tooltip>
                                  {actionColumn(row, historyRow)}
                                </>
                                : historyRow.statusID == 3 ? <Chip label="Processing" variant="outlined" color='success' />
                                  : historyRow.statusID == 5 ? <Chip label="Complete" variant="outlined" color='success' />
                                    : <Chip label="Ready To Weighment" variant="outlined" color='success' />}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </Box> : <Typography variant="h7" gutterBottom component="div">
                  <b>No Supplier Details</b>
                </Typography>}
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const priceOrderUpdateSearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    operationEntityID: Yup.number().min(1, 'Please Select Operation Entity').required('Operation Entity required'),
    dateID: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      dateID: formData.dataID
    },

    validationSchema: priceOrderUpdateSearchSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm());
    }
  });

  async function SubmitForm() {
    setOrderDetails([]);
    var res = await services.GetVCCOrderDetails(formik.values.operationEntityID, formik.values.dateID);
    res.sort((a, b) => a.productName > b.productName ? 1 : -1);
    setOrderDetails(res);
  }

  async function GetMergeCropDetailsByPerformOrderID(data) {
    var res = await services.GetMergeCropDetailsByPerformOrderID(data.performOrderID);
    if (res != null) {
      setMergeCropDetails(res)
    }
  }

  async function GetSupplierDetailsForOrder(data) {
    var res = await services.GetSupplierDetailsForOrder(data.operationEntityID, data.cropID, data.orderDate);
    if (res != null) {
      setSupllierDetails(res);
    }
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  async function clearAll() {
    formik.resetForm();
    setIsTable(false);
  }

  useEffect(() => {
    getPermissions();
  }, [])

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    trackPromise(GetSupplierCropVarityQuntityDetails(supplierData.farmerID));
    calSupplierDetails(supplierData.farmerID);
  }, [supplierData.farmerID]);

  useEffect(() => {
    supplierQuntityCal(supplierData.quantity);
  }, [supplierData.quantity]);

  useEffect(() => {
    if (isUpdate == false) {
      calSupplierVarityDetails(supplierData.cropVarityID);
    }
  }, [supplierData.cropVarityID]);

  useEffect(() => {
    if (isUpdate == false) {
      let model = {
        operationEntityID: values.operationEntityID,
        cropID: supplierData.cropID,
        orderDate: values.dateID
      }
      trackPromise(GetSupplierDetailsForOrder(model))
    }
  }, [supplierData.cropID]);

  useEffect(() => {
    setOrderDetails([]);
  }, [formik.values.operationEntityID]);

  useEffect(() => {
    setOrderDetails([]);
  }, [formik.values.dateID]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWORDERAMENDEMENT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
    trackPromise(GetAllGroups());
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  async function GetSupplierCropVarityQuntityDetails(farmerID) {
    var res = await services.GetSupplierCropVarityQuntityDetails(farmerID, supplierData.cropID, supplierOrderDeails.orderDate);
    if (res != null) {
      const result = res.filter(x => x.quantity > 0)
      setSupllierVarityDetails(res);
      setSupllierVarityDetailsTwo(result);
    }
  }

  function calSupplierDetails(data) {
    const result = supllierDetails.find(x => x.farmerID == parseInt(data))
    if (result != undefined) {
      setSupplierData({
        ...supplierData,
        date: supplierOrderDeails.orderDate.split('T')[0],
        availbaleQty: result.quantity,
        cropVarityID: 0
      });
    }
    else {
      setSupplierData({
        ...supplierData,
        date: "",
        availbaleQty: 0,
        cropVarityID: 0
      });
    }
  }

  function calSupplierVarityDetails(data) {
    const result = supllierVarityDetailsTwo.find(x => x.productVarietyID == parseInt(data))
    if (result != undefined) {
      setSupplierData({
        ...supplierData,
        quantity: result.quantity,
        cropForecastDetailID: result.cropForecastDetailID
      });
    }
    else {
      setSupplierData({
        ...supplierData,
        quantity: 0,
        cropForecastDetailID: 0
      });
    }
  }

  function supplierQuntityCal(data) {
    setSupplierData({
      ...supplierData,
      reaminCount: (supplierOrderDeails.reaminingQuantity - data) < 0 ? 0 : (supplierOrderDeails.reaminingQuantity - data)
    });
  }

  function handleAddSupplierChange(e) {
    const target = e.target;
    const value = target.value

    setSupplierData({
      ...supplierData,
      [e.target.name]: value
    });
  }

  function handleReturnChange(e) {
    const target = e.target;
    const value = target.value

    setReturnOrderData({
      ...returnOrderData,
      [e.target.name]: value
    });
  }

  function orderApprovePopUp(data) {
    setEnableConfirmMessage(true);
    setOrderApprovePopUpDetails(data)
  }

  async function viewFccOrderBreakdown(data) {
    var res = await services.GetVCCOrderBreakdownDetailsByPerformOrderID(data.performOrderID);
    if (res.length > 0) {
      let total = 0;
      res.forEach(x => {
        total = total + x.quantity;
      });
      setOrderBreakdownList(res)
      setOrderBreakdownTotal(total)
      setOpen2(true)
    }
  }

  function removeSupplierPopUp(data, data2) {
    setEnableConfirmMessage2(true);
    setRemoveSupplierDetails(data2);
    setRemoveSupplierOrderDetails(data);
  }

  function readyToWeighmentPopUp(data) {
    setReadyToWeighmentDetails(data)
    setEnableConfirmMessage3(true);
  }

  function confirmData(y) {
    if (y) {
      trackPromise(orderApprove(orderApprovePopUpDetails));
    }
  }

  function confirmData2(y) {
    if (y) {
      trackPromise(removeSupllier(removeSupplierDetails, removeSupplierOrderDetails));
    }
  }

  function confirmData3(y) {
    if (y) {
      trackPromise(approveReadyToWeighment(readyToWeighmentDetails))
    }
  }

  async function orderApprove(data) {
    var res = await services.ApproveOrder(data)
    if (res.statusCode === "Success") {
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
    trackPromise(SubmitForm());
  }

  async function removeSupllier(supplierDetails, SupplierOrderDetails) {
    const result = await calNewfarmerRemoveBreakDown(supplierDetails)
    var res = await services.RemoveSuppliers(supplierDetails, SupplierOrderDetails, result)
    if (res.statusCode === "Success") {
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
    trackPromise(SubmitForm());
  }

  async function approveReadyToWeighment(readyToWeighmentDetails) {
    var res = await services.ApproveReadyToWeighment(readyToWeighmentDetails)

    if (res.statusCode === "Success") {
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
    trackPromise(SubmitForm());
  }

  function addSupplierClearFields() {
    setSupplierData({
      ...supplierData,
      cropID: 0,
      farmerID: 0,
      cropVarityID: 0,
      quantity: 0,
      date: '',
      reaminCount: 0,
      availbaleQty: 0
    });
  }

  function actionColumn(row, historyRow) {
    if (row.status == 3 && row.isRealizedEdited == true) {
      return (
        <>
        </>)
    }
    else {
      if (row.realizedPriceOne <= 0) {
        return (
          <>
          </>)
      }
      else {
        return (
          <Tooltip title="Ready To Weighment" >
            <IconButton aria-label="delete"
              onClick={() => readyToWeighmentPopUp(historyRow)}
            >
              <CheckIcon />
            </IconButton>
          </Tooltip>)
      }
    }
  }

  function actionColumnOne(row) {
    if (row.status == 3 && row.isRealizedEdited == true) {
      return (<Chip label="Realized Price Not Set Yet" variant="outlined" color='error' />)
    }
    else {
      if (row.realizedPriceOne <= 0) {
        return (
          <Chip label="Realized Price Not Set Yet" variant="outlined" color='error' />
        )
      }
      else {
        return (
          parseFloat(row.realizedPriceOne).toFixed(2)
        )
      }
    }
  }


  async function AddSuppliers() {
    setIsLoading(true);
    if (isUpdate == false) {
      if (supplierData.farmerID != 0 && supplierData.cropVarityID != 0 && supplierData.quantity != 0) {
        var reg = new RegExp('^[0-9]{1,9}([.][0-9]{1,2})?$');
        if (reg.test(supplierData.quantity) == true) {
          var sumQty = supplierOrderDeails.quantity - supplierOrderDeails.returnQuantity
          if (supplierData.quantity <= (sumQty - supplierOrderDeails.acceptedQuantity)) {
            if (supplierData.quantity <= supplierData.availbaleQty) {
              const result = await calNewfarmerBreakDown(supplierOrderDeails)
              const found = supplierOrderDeails.farmerModel.find(x => x.cropVarietyID == supplierData.cropVarityID && x.farmerID == supplierData.farmerID)
              if (found == undefined) {
                var res = await services.AddSuppliers(supplierOrderDeails, supplierData, result)
                if (res.statusCode === "Success") {
                  toast.success(res.message);
                  handleClose();
                } else {
                  toast.error(res.message);
                }
                trackPromise(SubmitForm());
              }
              else {
                toast.error('Can not add same crop from same supplier');
              }
            }
            else {
              toast.error('Can not be greater than available quantity');
            }
          }
          else {
            toast.error('Can not be greater than requested quantity');
          }
        }
        else {
          toast.error("Allow Only Numbers");
        }
      }
      else {
        toast.error('Fill The All Required Fields');
      }
    }
    else {
      if (supplierData.quantity != 0) {
        var reg = new RegExp('^[0-9]{1,9}([.][0-9]{1,2})?$');
        if (reg.test(supplierData.quantity) == true) {
          var sumQty = supplierOrderDeails.acceptedQuantity - supplierData.availbaleQty
          if ((sumQty + parseFloat(supplierData.quantity)) <= (supplierOrderDeails.quantity - supplierOrderDeails.returnQuantity)) {
            trackPromise(GetSupplierCropVarityQuntityDetails(supplierData.farmerID));
            const found = supllierVarityDetails.filter(x => x.productVarietyID == supplierData.cropVarityID)
            const foundTwo = found.find(x => x.quantity > 0)
            const varietyTot = (foundTwo != undefined ? foundTwo.quantity + supplierData.availbaleQty : found[0].quantity + supplierData.availbaleQty)
            const result = await calNewfarmerEditBreakDown(supplierOrderDeails, supplierOrderUpdateDeails, supplierData)
            if (supplierData.quantity <= varietyTot) {
              var res = await trackPromise(services.EditSuppliers(supplierOrderDeails, supplierOrderUpdateDeails, supplierData, foundTwo != undefined ? foundTwo : found[0], result))
              if (res.statusCode === "Success") {
                toast.success(res.message);
                handleClose();
              } else {
                toast.error(res.message);
              }
              trackPromise(SubmitForm());
            }
            else {
              toast.error('Can not be greater than available quantity');
            }
          }
          else {
            toast.error('Can not be greater than requested quantity');
          }
        }
        else {
          toast.error("Allow Only Numbers");
        }
      }
      else {
        toast.error('Fill The All Required Fields');
      }
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }

  async function calNewfarmerBreakDown(data) {
    var res = await services.GetVCCOrderBreakdownDetailsByPerformOrderID(data.performOrderID);
    if (res.length > 0) {
      let result = [];
      const total = res.reduce((accumulator, current) => accumulator + current.quantity, 0);
      res.forEach(x => {
        let percentage = x.quantity / total
        result.push({
          outletOrderProductCode: x.outletOrderProductCode,
          outletOrderProductName: x.outletOrderProductName,
          quantity: supplierData.quantity * percentage
        })
      })
      return result;
    }
  }

  async function calNewfarmerRemoveBreakDown(data) {
    var res = await services.GetVCCOrderBreakdownDetailsByPerformOrderID(data.performOrderID);
    if (res.length > 0) {
      let result = [];
      const total = res.reduce((accumulator, current) => accumulator + current.quantity, 0);
      res.forEach(x => {
        let percentage = x.quantity / total
        result.push({
          outletOrderProductCode: x.outletOrderProductCode,
          outletOrderProductName: x.outletOrderProductName,
          quantity: data.acceptedQuantity * percentage
        })
      })
      return result;
    }
  }

  async function calNewfarmerEditBreakDown(data, dataOne, dataTwo) {
    var res = await services.GetVCCOrderBreakdownDetailsByPerformOrderID(data.performOrderID);
    if (res.length > 0) {
      let result = [];
      const total = res.reduce((accumulator, current) => accumulator + current.quantity, 0);
      const existsQtyTwo = parseFloat(dataOne.acceptedQuantity) - parseFloat(dataTwo.quantity);
      const existsQty = parseFloat(dataTwo.quantity) + parseFloat((existsQtyTwo));
      res.forEach(x => {
        let percentage = x.quantity / total
        result.push({
          outletOrderProductCode: x.outletOrderProductCode,
          outletOrderProductName: x.outletOrderProductName,
          newQuantity: supplierData.quantity * percentage,
          quantity: ((existsQty * percentage) - (supplierData.quantity * percentage)),
          farmerID: dataOne.farmerID,
          cropVarietyID: dataOne.cropVarietyID
        })
      })
      return result;
    }
  }

  async function setUpdateSupplier(row, historyRow) {
    trackPromise(GetSupplierDetailsForOrder(row));
    setIsUpdate(true);
    setOpen(true);
    setSupplierOrderDeails(row);
    setSupplierOrderUpdateDeails(historyRow);
    setSupplierData({
      ...supplierData,
      cropID: historyRow.cropID,
      cropName: historyRow.productName,
      farmerName: historyRow.givenName,
      varietyName: historyRow.varietyName,
      reaminCount: row.reaminingQuantity,
      date: row.orderDate.split('T')[0],
      quantity: historyRow.acceptedQuantity,
      farmerID: historyRow.farmerID,
      cropVarityID: historyRow.cropVarietyID,
      cropForecastDetailID: historyRow.cropForecastDetailID,
      availbaleQty: historyRow.acceptedQuantity
    })
  }

  async function returnOrder() {
    setIsLoading(true);
    if (returnOrderData.reason != "") {
      var res = await services.ReturnOrder(returnOrderData, supplierOrderDeailsTwo)
      if (res.statusCode === "Success") {
        toast.success(res.message);
        handleClose1();
      } else {
        toast.error(res.message);
      }
      trackPromise(SubmitForm());
    }
    else {
      toast.error('Fill The Reason Required Fields');
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }

  return (
    <>
      <LoadingComponent />
      <Page title="View FCC Orders  |  FAPS">
        <Container maxWidth>
          <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center *"
                    value={formik.values.operationEntityID}
                    onChange={formik.handleChange}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Operation Entity</MenuItem>
                    {operationEntityList.map((option) => (
                      option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    fullWidth
                    id="outlined-start-adornment"
                    size="small"
                    label="Date *"
                    type="Date"
                    value={formik.values.dateID}
                    onChange={formik.handleChange}
                    {...getFieldProps('dateID')}
                    error={Boolean(touched.dateID && errors.dateID)}
                    helperText={touched.dateID && errors.dateID}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>
                    }}
                    inputProps={{
                      min: new Date().toISOString().split('T')[0],
                      max: new Date().toISOString().split('T')[0],
                    }}
                  >
                  </TextField>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <Button type="submit" color="secondary" variant="outlined">
                      Search
                    </Button>
                  </Stack>
                </Stack>
                <br />
                <>
                  {orderDetails.length != 0 ?
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Card style={{ justifycontent: 'center', width: '100%' }}>
                        <Paper className={classes.root}>

                          <TableContainer component={Paper} style={{ maxHeight: '550px', overflowY: 'auto' }}>
                            <Table className={classes.table} size="small" aria-label="sticky table" Table stickyHeader >
                              <TableHead style={{ position: "sticky", top: 0, zIndex: 1000, background: "white" }}>
                                <TableRow style={{ borderTop: "1px solid black" }}>
                                  <TableCell />
                                  <TableCell style={{ fontWeight: 'bold' }} align='left'>Crop</TableCell>
                                  <TableCell align="left" style={{ fontWeight: 'bold' }}>SKU</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Proposed Price</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Realized Price</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Requested Qty</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Accepted Qty</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Remaining Qty</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Return Qty</TableCell>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody >
                                {orderDetails.map((row) => (
                                  <Row key={row.performOrderID} row={row} />
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Paper>
                      </Card>
                    </Stack> : <SearchNotFound searchQuery="FCC Orders" />}
                </>
              </Stack>
            </Form>
          </FormikProvider>
          <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{isUpdate == false ? "Add Supplier" : "Edit Supplier"}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {isUpdate == false ?
                  <>
                    Remaining Qty : {parseFloat(supplierData.reaminCount).toFixed(2)}
                    <br />
                  </> : null}

                <br />
                {isUpdate == false ?
                  <TextField
                    select
                    fullWidth
                    size="small"
                    id="outlined-basic"
                    name='cropID'
                    variant="outlined"
                    label="Crop *"
                    value={supplierData.cropID}
                    onChange={(e) => { handleAddSupplierChange(e) }}
                  >
                    <MenuItem key={0} value={0}> Select Crop</MenuItem>
                    {mergeCropDetails.map((option) => (
                      <MenuItem key={option.productID} value={option.productID}>
                        {option.productName}
                      </MenuItem>
                    ))}
                  </TextField> :
                  <form noValidate autoComplete="off" className={popUpClass.root}>
                    <TextField
                      id="outlined-basic"
                      size="small"
                      label="Crop *"
                      variant="outlined"
                      name='cropName'
                      value={supplierData.cropName}
                      onChange={(e) => { handleAddSupplierChange(e) }}
                      InputProps={{
                        readOnly: true
                      }}
                    />
                  </form>}
                <br />
                {isUpdate == false ?
                  <>
                    <br />
                    <TextField
                      select
                      fullWidth
                      size="small"
                      id="outlined-basic"
                      name='farmerID'
                      variant="outlined"
                      label="Supplier *"
                      value={supplierData.farmerID}
                      onChange={(e) => { handleAddSupplierChange(e) }}
                    >
                      <MenuItem key={0} value={0}> Select Supplier</MenuItem>
                      {supllierDetails.map((option) => (
                        option.quantity > 0 ? <MenuItem key={option.farmerID} value={option.farmerID}>
                          {option.firstName}
                        </MenuItem> : null
                      ))}
                    </TextField> </> :
                  <form noValidate autoComplete="off" className={popUpClass.root}>
                    <TextField
                      id="outlined-basic"
                      size="small"
                      label="Supplier *"
                      variant="outlined"
                      name='farmerName'
                      value={supplierData.farmerName}
                      onChange={(e) => { handleAddSupplierChange(e) }}
                      InputProps={{
                        readOnly: true
                      }}
                    />
                  </form>}
                <br />
                {isUpdate == false ?
                  <>
                    <br />
                    <TextField
                      select
                      fullWidth
                      size="small"
                      id="outlined-basic"
                      name='cropVarityID'
                      variant="outlined"
                      label="Crop Variety *"
                      value={supplierData.cropVarityID}
                      onChange={(e) => { handleAddSupplierChange(e) }}
                    >
                      <MenuItem key={0} value={0}> Select Crop Variety</MenuItem>
                      {supllierVarityDetailsTwo.map((option) => (
                        option.quantity > 0 ? <MenuItem key={option.productVarietyID} value={option.productVarietyID}>
                          {option.varietyName}
                        </MenuItem> : null
                      ))}
                    </TextField> </> :
                  <form noValidate autoComplete="off" className={popUpClass.root}>
                    <TextField
                      id="outlined-basic"
                      size="small"
                      label="Crop Variety *"
                      variant="outlined"
                      name='varietyName'
                      value={supplierData.varietyName}
                      onChange={(e) => { handleAddSupplierChange(e) }}
                      InputProps={{
                        readOnly: true
                      }}
                    />
                  </form>}
                <form noValidate autoComplete="off" className={popUpClass.root}>
                  <br />
                  <TextField
                    id="outlined-basic"
                    size="small"
                    label="Quantity *"
                    variant="outlined"
                    name='quantity'
                    value={supplierData.quantity}
                    onChange={(e) => { handleAddSupplierChange(e) }}
                  />
                </form>
                <br />
                <TextField
                  fullWidth
                  size="small"
                  id="date"
                  label="Date"
                  type="date"
                  name='date'
                  value={supplierData.date}
                  onChange={(e) => { handleAddSupplierChange(e) }}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    readOnly: true
                  }}
                />
                <br />
                <br />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="secondary">
                CANCEL
              </Button>
              <LoadingButton
                color="secondary"
                onClick={AddSuppliers}
                loading={isLoading}
                variant="text"
              >
                {isUpdate == false ? "ADD" : "UPDATE"}
              </LoadingButton>
            </DialogActions>
          </Dialog>
          <div hidden={true}>
            <Grid item>
              <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                discription={"Are you sure want to approve this order ?"} setViewPopup={setEnableConfirmMessage} />
            </Grid>
          </div>
          <div hidden={true}>
            <Grid item>
              <AlertDialog confirmData={confirmData2} headerMessage={message2} viewPopup={EnableConfirmMessage2}
                discription={"Are you sure want to remove this supplier ?"} setViewPopup={setEnableConfirmMessage2} />
            </Grid>
          </div>
          <div hidden={true}>
            <Grid item>
              <AlertDialog confirmData={confirmData3} headerMessage={message3} viewPopup={EnableConfirmMessage3}
                discription={"Are you sure want to approve this order ?"} setViewPopup={setEnableConfirmMessage3} />
            </Grid>
          </div>
          <Dialog open={open1} onClose={handleClose1} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Return Order</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Date : {supplierOrderDeailsTwo.orderDate == undefined ? '-' : supplierOrderDeailsTwo.orderDate.split('T')[0]}
                <br />
                Collection Center : {supplierOrderDeailsTwo.factoryName == undefined ? '-' : supplierOrderDeailsTwo.factoryName}
                <br />
                Crop : {supplierOrderDeailsTwo.productName == undefined ? '-' : supplierOrderDeailsTwo.productName}
                <br />
                Return Qty : {supplierOrderDeailsTwo.reaminingQuantity == undefined ? '-' : supplierOrderDeailsTwo.reaminingQuantity} (Kg)
                <br />
                <br />
                <form noValidate autoComplete="off" className={popUpClass.root}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    size="small"
                    label="Reason *"
                    variant="outlined"
                    name='reason'
                    value={returnOrderData.reason}
                    onChange={(e) => { handleReturnChange(e) }}
                  />
                </form>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose1} color="secondary">
                CANCEL
              </Button>
              <LoadingButton
                color="secondary"
                onClick={returnOrder}
                loading={isLoading}>
                CONFIRM
              </LoadingButton>
            </DialogActions>
          </Dialog>
          <Dialog open={open2} onClose={handleClose2} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Order Breakdown</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold' }} align="left">Crop</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }} align="left">SKU</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }} align="right">Quantity</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orderBreakdown.map((row) => (
                      <TableRow>
                        <TableCell align="left">
                          {row.outletOrderProductName}
                        </TableCell>
                        <TableCell align="left">{row.outletOrderProductCode}</TableCell>
                        <TableCell align="right">{parseFloat(row.quantity).toFixed(2)}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold' }} align="left" colSpan={2}>
                        Total
                      </TableCell>
                      <TableCell style={{ fontWeight: 'bold' }} align="right">{parseFloat(orderBreakdownTotal).toFixed(2)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose2} color="secondary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Page>
    </>
  );
}
